import { Component, OnInit, ViewChild, ElementRef, Input, Inject, ChangeDetectorRef, DOCUMENT } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { SettingsService } from '../settings/settings.service';
import { Router } from '@angular/router';

import { PostHogService } from '../services/posthog.register.service';

declare var $: any;

@Component({
    selector: 'app-mirai-cliente',
    templateUrl: './mirai-cliente.html',
    styleUrls: ['./mirai-cliente.less'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(20px)' }),
                animate('300ms', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'translateY(0)' }),
                animate('300ms', style({ opacity: 0, transform: 'translateY(20px)' }))
            ])
        ])
    ],
    standalone: false
})
export class MiraiCliente implements OnInit {
  @ViewChild('chatContent') private chatContent!: ElementRef;
  @Input() initials:any;
  @Input() full_name:any;
  @Input() avatar:any;
  id_company = localStorage.getItem('company_id')

  avatarBackground: string = '';
  showInitials: boolean = true;

  chatVisible = false;
  userOption: string | null = null;
  botResponse: string | null = null;
  currentDate!: Date;
  userMessage: string = '';
  userMessages: any[] = [];
  observation:any;

  isRecording: boolean = false;
  recordingSeconds: number = 0;
  recordingInterval: any;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  recordedAudioBase64: string = '';

  currentAudioIndex: number | null = null;
  isPlaying: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  audioElement: HTMLAudioElement | null = null;

  constructor(
    private settings:SettingsService, 
    private router: Router, 
    @Inject(DOCUMENT) private document: Document, 
    private cdRef: ChangeDetectorRef,
    private posthog: PostHogService
  ){
  }

  ngOnInit() {
 
    this.currentDate = new Date();
    console.log("AVATARRR", this.avatar);
    //this.avatarBackground = this.generateRandomBackground();
  }

  toggleChat() {
    this.chatVisible = !this.chatVisible;

    if(this.chatVisible){
      this.posthog.capture(
        'clara',
        null,
        null,
        'El usuario accedió al apartado de Clara',
        'web'
      );
    }
  }

  selectOption(option: any, msg:string) {

    switch(option) {
      case 1:
        this.sendMessage_prefix(msg)
        this.botResponse = `
        ¡Con gusto te ayudaré! Es necesario que sepas lo siguiente de nuestros servicios:<br><br>

        Tenemos un gran ecosistema de servicios, que van desde el Pronto Pago a proveedores hasta el financiamiento de órdenes de compra (Ordering).<br><br>

        Conoce cada uno de los servicios de nuestro ecosistema en detalle, <a href="https://www.simplilatam.com/" target="blank">haciendo clic aquí</a>.<br><br>

        Si necesitas más ayuda, no dudes en escribirme.
      `;
        this.generateBotResponse_prefix(this.botResponse)
        break;
      case 2:
        this.sendMessage_prefix(msg)
        this.botResponse = `
        ¡Esto sí es interesante! Referente al funcionamiento del Factoring en Simpli, debes saber lo siguiente:<br><br>

        Antes de realizar la cesión de las facturas seleccionadas, <strong>se debe evaluar la operación</strong>, con el fin de calcular los costos asociados. 
        Esto se puede lograr a través de la simulación de operaciones.<br><br>

        Una vez que <strong>la operación es aprobada</strong> por la empresa que solicita el financiamiento y por Simpli, se hace entrega del adelanto de las cuentas por cobrar.<br><br>

        Por último, Simpli <strong>realiza la cobranza de las facturas al cliente.</strong> Una vez que este pague, se transfiere <strong>el saldo que quedó pendiente de la factura (excedente).<strong>

        <br><br>
        Si necesitas más ayuda, no olvides que puedes escribirme.
        `;
        this.generateBotResponse_prefix(this.botResponse)
        break;
      case 3:
        this.sendMessage_prefix(msg)
        this.botResponse = `
        ¡Muy bien! Te ayudaré con esto. Solo guíate por la siguiente información:<br><br>

        Ingresa al menú ubicado en el costado izquierdo de la plataforma y selecciona <strong>“Simulaciones”</strong> para visualizar la operación que dará paso a la cesión. 
        Haz clic en <strong>“Detalle”</strong> para revisar el Certificado Digital Electrónico que está cargado. Si ves todo en orden, presiona <strong>“Aceptar y Continuar”</strong>.<br><br>

        Si el Certificado Digital Electrónico no está en nuestro sistema, puedes cargar el archivo <strong>“AEC”</strong> haciendo clic en <strong>“Estado AEC”</strong>.<br><br>

        Si necesitas ayuda con algo más, no dudes en escribirme.
      `;
        this.generateBotResponse_prefix(this.botResponse)
        break;
        case 4:
          this.sendMessage_prefix(msg)
          this.botResponse = `
          ¡Muy bien! Con gusto te ayudaré.<br><br>

          Para realizar una simulación, ingresa a <strong>simula tu operación</strong>, elige las facturas que quieres simular y completa el proceso.<br><br>

          También puedes <strong>contactar a tu ejecutivo</strong> para solicitar su ayuda.<br><br>

          Además te llevaré a la pantalla de simular en 20 segundos, espero haberte ayudado.

        `;
          this.generateBotResponse_prefix(this.botResponse)
          break;
    }
    //this.userMessages.push(this.botResponse);
    this.currentDate = new Date();
    this.scrollToBottom();
  }

  countdown: number = 10; 
  intervalId: any; 
  go_to_simular(){

    this.intervalId = setInterval(() => {
      this.countdown = this.countdown - 1;
      if (this.countdown <= 0) {
        clearInterval(this.intervalId);
        this.performAction();
      }
    }, 2000);


  }

  performAction() {
    const element = this.document.getElementById('caja_excel');
    if (element) {
      element.click();
      const index = this.userMessages.findIndex(message => message.includes("Además te llevaré a la pantalla de simular en 20 segundos Espero haberte ayudado"));

      let updatedMessage = `
            ¡Muy bien! Con gusto te ayudaré.<br><br>
  
            Para realizar una simulación, ingresa a <strong>simula tu operación</strong>, elige las facturas que quieres simular y completa el proceso.<br><br>
  
            También puedes <strong>contactar a tu ejecutivo</strong> para solicitar su ayuda.<br><br>
  
            Ahora te encuentras en la pantalla de simular.
  
          `;
  
      this.userMessages[index] = updatedMessage;
    } else {
      this.router.navigate(['home']).then(() => {
        const homeElement = this.document.getElementById('caja_excel');
        if (homeElement) {
          homeElement.click();
        }
      });
    }
  }

  resetChat() {
    this.userOption = null;
    this.botResponse = null;
    this.userMessages = [];
    this.userMessage = '';
  }

  escribiendo:boolean=false;
  sendMessage() {
    if (this.userMessage.trim()) {
      this.userMessages.push({
        content: this.userMessage,
        type: 'text'
      });
      console.log("MENSAJE", this.userMessages)
      this.send_msg(this.userMessage);
      this.userMessage = '';
      this.currentDate = new Date();
      this.scrollToBottom();
    }
  }

  generateBotResponse(userMessage: string) {
    let botResponse = userMessage;

    this.userMessages.push({
      content: botResponse,
      type: 'text'
    });
  }


  sendMessage_prefix(msg:string) {
    if (msg.trim()) {
      this.userMessages.push({
        content: msg,
        type: 'text'
      });
      this.userMessage = '';
      this.currentDate = new Date();
      this.scrollToBottom();
    }
  }

  generateBotResponse_prefix(userMessage: string) {
    let botResponse = userMessage;

    this.userMessages.push({
      content: userMessage,
      type: 'text'
    });
  }

  scrollToBottom() {
    setTimeout(() => {
      this.chatContent.nativeElement.scrollTop = this.chatContent.nativeElement.scrollHeight;
    }, 0);
  }

  generateRandomBackground(): string {
    const colors = ['#924eff', '#3b86ff', '#ff81f1', 'var(--simpli-primary)', '#ff2982', '#1b0943'];
    const randomIndex1 = Math.floor(Math.random() * colors.length);
    let randomIndex2 = Math.floor(Math.random() * colors.length);

    while (randomIndex2 === randomIndex1) {
        randomIndex2 = Math.floor(Math.random() * colors.length);
    }

    return `linear-gradient(-50deg, #9B56F6, #DD73F2)`;
  }


  disabled:boolean=false;
  async send_msg(msg:string) {
    try {
      this.disabled = true;
      this.escribiendo = true;

      const value = { "input_client": msg, "audio_client": ""};

      const bd: any = await this.settings.get_query(
          2,
          '/cliente/chat-ai/' + this.id_company + "/", value
        );

      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:

            console.log(body_data)
            this.escribiendo = false;
            this.disabled = false;


            this.generateBotResponse(body_data.success.info);
            this.scrollToBottom();


            setTimeout(() => {
              this.focusInput();
            });

          break;
        default:

          break;
      }
    } catch (bd: any) {

      this.escribiendo = false;
      this.disabled = false;

      this.generateBotResponse("Vaya, mis sistemas colapsaron con esa pregunta <span style='margin-left:10px;margin-right:10px;' class='material-symbols-outlined'>sentiment_very_dissatisfied</span>, intentalo de nuevo, ¡estoy aprendiendo para ser la mejor!");
      this.scrollToBottom();

      setTimeout(() => {
        this.focusInput();
      });
    }
  }

  @ViewChild('inputclara') inputClara!: ElementRef;
  focusInput() {
      this.cdRef.detectChanges();
      this.inputClara.nativeElement.focus();
      $("#inputclara").trigger('focus')
  }

  isValidAvatar(avatar: any): boolean {
    return typeof avatar === 'string' && avatar.trim() !== '' && avatar !== undefined && avatar !== null;
  }

  handleAvatarError(): void {
    this.avatar = '';
  }


  //Iniciar grabación
  async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(stream);
      this.audioChunks = [];
      
      this.mediaRecorder.addEventListener('dataavailable', (event) => {
        this.audioChunks.push(event.data);
      });
      
      this.mediaRecorder.addEventListener('stop', () => {
        this.processRecordedAudio();
      });
      
      this.mediaRecorder.start();
      this.isRecording = true;
      this.recordingSeconds = 0;
      
      this.recordingInterval = setInterval(() => {
        this.recordingSeconds++;
      }, 1000);
      
    } catch (error) {
      console.error('Error al acceder al micrófono:', error);
      alert('No se pudo acceder al micrófono');
    }
  }

  stopRecording() {
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop();
      this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
      this.isRecording = false;
      clearInterval(this.recordingInterval);
    }
  }

  async processRecordedAudio() {
    const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
    
    const base64Audio = await this.blobToBase64(audioBlob);
    this.recordedAudioBase64 = base64Audio;
    
    const audioUrl = URL.createObjectURL(audioBlob);

    console.log("AUDIOOOO", audioUrl);

    this.userMessages.push({
      content: audioUrl,
      type: 'audio'
    });

    console.log("USER MESSAGES", this.userMessages);

    this.currentDate = new Date();
    this.scrollToBottom();
    
    this.sendAudioMessage(this.recordedAudioBase64);
  }

  // Convertir blob a base64
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        // Remover el prefijo data:audio/wav;base64,
        const base64Data = base64String.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  async sendAudioMessage(audioBase64: string) {
    try {
      this.disabled = true;
      this.escribiendo = true;
      
      const value = { "input_client": "", "audio_client": audioBase64};

      const bd: any = await this.settings.get_query(
          2,
          '/cliente/chat-ai/' + this.id_company + "/", value
        );

      setTimeout(() => {
        const body_data: any = bd._body;
        this.escribiendo = false;
        this.disabled = false;
        this.generateBotResponse(body_data.success.info)
        this.scrollToBottom();
      }, 2000);
      
    } catch (error) {
      this.escribiendo = false;
      this.disabled = false;
      this.generateBotResponse("No pude procesar tu audio, inténtalo de nuevo.");
      this.scrollToBottom();
    }
  }

  hasTextInput(): boolean {
    return this.userMessage.trim().length > 0;
  }

  formatRecordingTime(): string {
    const minutes = Math.floor(this.recordingSeconds / 60);
    const seconds = this.recordingSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  toggleAudio(audioUrl: string, messageIndex: number) {
    if (this.currentAudioIndex === messageIndex && this.isPlaying) {
      this.pauseAudio();
      return;
    }

    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement = null;
    }

    this.audioElement = new Audio(audioUrl);
    this.currentAudioIndex = messageIndex;
    
    this.audioElement.addEventListener('loadedmetadata', () => {
      this.duration = this.audioElement!.duration;
    });

    this.audioElement.addEventListener('timeupdate', () => {
      this.currentTime = this.audioElement!.currentTime;
    });

    this.audioElement.addEventListener('ended', () => {
      this.isPlaying = false;
      this.currentAudioIndex = null;
      this.currentTime = 0;
    });

    this.audioElement.play().then(() => {
      this.isPlaying = true;
    }).catch(error => {
      console.error('Error al reproducir audio:', error);
    });
  }

  pauseAudio() {
    if (this.audioElement) {
      this.audioElement.pause();
      this.isPlaying = false;
    }
  }

  getAudioProgress(messageIndex: number): number {
    if (this.currentAudioIndex === messageIndex && this.duration > 0) {
      return (this.currentTime / this.duration) * 100;
    }
    return 0;
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  }

  isAudioPlaying(messageIndex: number): boolean {
    return this.currentAudioIndex === messageIndex && this.isPlaying;
  }

}
